(function(require2) {
  "use strict";
  var boot = function() {
    require2(["app"], function(app) {
      app.bootstrap(document);
    });
  };
  require2(["api-keys"], function(apiKeys) {
    apiKeys.load().then(boot);
  });
})(require);
